import React, { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import {
  renderFieldText,
  RenderFieldPhone,
  renderHiddenFieldText,
} from "@basecomponent";
import { classNames } from "@utilscommon";
import ImageCropper from "@imagecropper";
import LocaleStrings from "@language";
import { useLocalStorage, LOCAL_STORAGE } from "@useLocalStorage";

const FixedFields = (props) => {
  let { source, formValues, eventData, eventSettingsData, checkoutFormData } =
    props;
  const { getLocalStorage } = useLocalStorage();
  const socialDetails = getLocalStorage(LOCAL_STORAGE.USER_SOCIAL_DETAILS);
  const loginScreen = getLocalStorage(LOCAL_STORAGE.LOGIN_SCREEN);
  // console.log("checkoutFormData :- ", checkoutFormData);
  // console.log("formValues :- ", formValues);

  let signupwith = formValues?.signupwith ?? "email";
  let eventId = eventData?.eventid;
  // Check if phone numbed exists or not in checkout form
  let formJson = checkoutFormData?.data?.formjson ?? "{}";
  let formArray = JSON.parse(formJson);
  let checkPhone = _.filter(formArray, (obj) => obj.name === "phonenumber");
  let countrycode = checkPhone?.[0]?.defaultvalue ?? ""; // default country code checking
  let dropdowndisabled =
    countrycode && countrycode !== "" ? checkPhone?.[0]?.isrestricted : false; // disabled country dropdownlist
  let profileOptionn = checkoutFormData?.data?.profileimage ?? "optional";
  // console.log("profileOptionn :- ", profileOptionn);
  let imagePreviewUrl =
    formValues?.profileurl ?? socialDetails?.profileurl ?? "";
  let speakerimagePreviewUrl =
    formValues?.speakerprofileurl ?? socialDetails?.profileurl ?? "";
  let custom_settings = JSON.parse(
    eventSettingsData?.data?.custom_settings ?? "{}"
  );
  let allowPhoneSignup = custom_settings?.enable_phone_based_login ?? false;
  let formType =
    checkoutFormData?.data?.appuser_groups_by_formid?.[0]?.type ?? "";
  const createspeaker =
    JSON.parse(checkoutFormData?.data?.commonsetting ?? "{}")?.createspeaker ??
    true;
  // console.log({ test: checkoutFormData?.commonsetting });

  useEffect(() => {
    if (_.isEmpty(formValues) || _.isEmpty(formValues?.name)) {
      expressCheckoutCompletion();
    }
  }, []);

  const onProfileImageSave = (img) => {
    // console.log("img :- ", img);

    props.autofill("profileurl", img === "" ? "" : img);
  };
  const onSpeakerImageSave = (img) => {
    // console.log("img :- ", img);

    props.autofill("speakerprofileurl", img === "" ? "" : img);
  };

  const expressCheckoutCompletion = () => {
    if (!_.isEmpty(loginScreen) && !_.isEmpty(socialDetails)) {
      imagePreviewUrl = socialDetails?.profileurl ?? "";
      props.autofill("profileurl", socialDetails?.profileurl ?? "");
      props.autofill("firstname", socialDetails?.firstname ?? "");
      props.autofill("lastname", socialDetails?.lastname ?? "");
      props.autofill("email", socialDetails?.email ?? "");
    }
  };

  const _handleSignUpWith = () => {
    let signup = signupwith === "email" ? "phonenumber" : "email";

    if (signup === "email") {
      props.autofill("phonenumber", "");
    } else {
      props.autofill("email", "");
    }

    props.autofill("signupwith", signup);
  };

  return (
    <>
      <div
        className={
          formType == "speaker" && createspeaker
            ? "md:grid md:grid-cols-9 md:grid-flow-row md:space-x-6"
            : "md:grid md:grid-cols-7 md:grid-flow-row md:space-x-6"
        }
        style={
          formType == "speaker" && createspeaker ? { marginRight: "30px" } : {}
        }
      >
        {profileOptionn !== "hide" ? (
          <div className="col-span-2">
            <div className="space-y-1 2xs:space-y-1.5">
              <label className="control-label-top col-span-12">
                {LocaleStrings.kLabelProfilePic}

                {profileOptionn === "mandatory" ? (
                  <span className="label-mandatory">*</span>
                ) : (
                  ""
                )}
              </label>
              <ImageCropper
                displaySize={{ width: 200, height: 200 }} // For image display style
                requiredSize={{ width: 200, height: 200 }} // For image size required validation
                cropperSize={{ width: 160, height: 160 }} // Cropper display size. Note its add 50px for padding
                onImageSave={onProfileImageSave}
                imagepath={imagePreviewUrl}
                border={10}
                displayText={LocaleStrings.kFileDragDropText}
                fileSizeText={LocaleStrings.kFileMinSizeText}
                imageType="jpg"
                className=""
              />
              <Field
                name="profileurl"
                type="text"
                component={renderHiddenFieldText}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <div
          className={classNames(
            profileOptionn !== "hide" ? "col-span-5" : "col-span-7",
            "base-form"
          )}
        >
          {source === "registration" &&
          allowPhoneSignup &&
          checkPhone.length > 0 ? (
            <>
              {signupwith === "phonenumber" ? (
                <>
                  <Field
                    name={checkPhone?.[0]?.name}
                    label={checkPhone?.[0]?.label}
                    type={"number"}
                    component={RenderFieldPhone}
                    mandatory={true}
                    eventid={eventId}
                    countyecode={countrycode}
                    isrestricted={dropdowndisabled}
                  />
                  <Field
                    name="signupwith"
                    type="text"
                    component={renderHiddenFieldText}
                  />
                </>
              ) : (
                <Field
                  name="email"
                  label={LocaleStrings.kEmail}
                  placeholder={""}
                  type="text"
                  component={renderFieldText}
                  mandatory={true}
                />
              )}

              <div className="flex justify-start items-center relative">
                <span
                  className="custom-text-theme-xs-normal underline cursor-pointer absolute right-0"
                  onClick={_handleSignUpWith}
                >
                  {signupwith === "phonenumber"
                    ? LocaleStrings.kRegisterWithEmailText
                    : LocaleStrings.kRegisterWithPhoneText}
                </span>
              </div>
            </>
          ) : (
            <Field
              name="email"
              label={LocaleStrings.kEmail}
              placeholder={""}
              type="text"
              component={renderFieldText}
              mandatory={true}
            />
          )}
          <Field
            name="firstname"
            label={LocaleStrings.kFirstName}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
          <Field
            name="lastname"
            label={LocaleStrings.kLastName}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
        </div>
        {formType == "speaker" && profileOptionn !== "hide" && createspeaker ? (
          <div className="col-span-2">
            <div className="space-y-1 2xs:space-y-1.5">
              <label className="control-label-top col-span-12">
                {LocaleStrings.kSpeakerProfilePic}

                {profileOptionn === "mandatory" ? (
                  <span className="label-mandatory">*</span>
                ) : (
                  ""
                )}
              </label>
              <ImageCropper
                displaySize={{ width: 200, height: 300 }} // For image display style
                requiredSize={{ width: 320, height: 480 }} // For image size required validation
                cropperSize={{ width: 187, height: 280 }} // Cropper display size. Note its add 50px for padding
                onImageSave={onSpeakerImageSave}
                imagepath={speakerimagePreviewUrl}
                border={10}
                displayText={LocaleStrings.kFileDragDropText}
                fileSizeText={LocaleStrings.kFileMinSizeText}
                imageType="jpg"
                className=""
              />
              <Field
                name="speakerprofileurl"
                type="text"
                component={renderHiddenFieldText}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    eventData: state.eventData,
    eventSettingsData: state.eventSettingsData,
    checkoutFormData: state.checkoutFormData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FixedFields);
